let NumberFormat;

// Try to create a number formatter to automatically shorten long numbers, i.e. 13,390 -> 13K
if (Intl && Intl.NumberFormat) {

	try {

		// TODO: Internationalize this dynamically based on the organization/user's language!
		NumberFormat = new Intl.NumberFormat('en', {
			notation: 'compact',
		});

	} catch (error) {
		console.error('Error creating NumberFormat for "en" count.', error);
	}

}

export const formatNumber = (number) => {

	if (NumberFormat) {
		return NumberFormat.format(number);
	}

	return number;

};
